// @Angular
import { Injectable } from '@angular/core';

// RXJS
import { Observable } from "rxjs/Observable";

// Store
import { Store } from '@ngrx/store';
import { getRouter, getUser } from '@api/store/app-store';

declare var window: any;

const APPID = 'App';
const MSGID = 'Msg'
const ERRORID = 'Msg'

@Injectable()
export class NewRelicService {

	// router
	private router$: Observable<any>;

	/**
	 * 
	 * @param store 
	 */
	constructor(private store: Store<any>) {
		this.router$ = this.store.select(getRouter);
	}

	public addPageAction(action: string, app: string, message: string, type: string) {		
	}

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/services/new-relic.service.ts